module.exports = __webpack_public_path__ + "media/admin/asset-manager/assets/no-image-132c5b99ac942587be2153cb95bc5236.svg";